import React, { FC, useEffect, useRef, useState } from 'react'
import { HeaderUserMenu } from '../../../partials'
import { UserModel } from '../../../../app/modules/auth/models/UserModel'
import { shallowEqual, useSelector } from 'react-redux'
import { RootState } from '../../../../setup'
import { Link } from 'react-router-dom'
import { useLanguageStore } from '../../../../stores/LanguageStore'
import ReactCountryFlag from 'react-country-flag'
import { useIntl } from 'react-intl'
import useAccessToken from '../../../../hooks/AccessToken'
import moment from "moment";
import { Modal } from 'bootstrap'
import useSWR from 'swr'
import NotificationLog from '../../../../components/NotificationLog/NotificationLog'
import { Notification } from '../../../../interfaces/NotificationLog/notification'
import { KTSVG, toAbsoluteUrl } from '../../../helpers'
import axios from 'axios'
import { customNumberFormat, formatBytes } from '../../../../functions/general'
import DetailNotificationLog from '../../../../components/NotificationLog/DetailNotificationLog'
import useNotificationStore from '../../../../stores/Notification'
import ModalEditAvatar from '../../../../components/Avatar/ModalEditAvatar'
import useModalEffect from '../../../../hooks/useModalEffect'

const API_URL = process.env.REACT_APP_API_URL
const APP_ENV = process.env.REACT_APP_ENV

const Topbar: FC = () => {
  const user: UserModel = useSelector<RootState>(({ auth }) => auth.user, shallowEqual) as UserModel
  const token = useAccessToken()
  const intl = useIntl()
  const { locale } = useLanguageStore()
  const [showUpdateProfilePicture, setShowUpdateProfilePicture] = useState(false)
  const { showDetailNotification, setShowDetailNotification, detailNotification } = useNotificationStore()
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const fetcherCorporate = (url: string) => axios.post(url, {}, {
    headers: {
      'X-Auth-token': user.data.companyCorporateToken
    }
  }).then(res => res.data.data)

  const fetcher = async (url: string) => {
    const response = await axios.get(url, {
      headers: {
        'X-Auth-token': token,
      },
    });
    return response.data.data;
  };

  const { data: dataNotif, isLoading, mutate: mutateNotif } = useSWR<Notification[]>(`${API_URL}crm-notifications/data-all?timezone=${timezone}`, fetcher)
  const { data: userProfile, isLoading: isLoadingProfile, mutate: mutateProfile } = useSWR(`${API_URL}user-profile-picture`, fetcher)

  const getUnreadNotif = dataNotif?.filter((notif: Notification) => !notif.readtime)
  moment.locale(locale)
  const [isShowModalLanguage, setIsShowModalLanguage] = useState(false)
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement | null>(null);
  const dropdownLanguageRef = useRef<HTMLDivElement | null>(null);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsDropdownOpen(false);
      }
      if (dropdownLanguageRef.current && !dropdownLanguageRef.current.contains(event.target as Node)) {
        setIsShowModalLanguage(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useModalEffect({
    showModal: isShowModalLanguage,
    setShowModal: setIsShowModalLanguage,
    modalId: `language-modal`
  })

  return (
    <div className='d-flex align-items-center flex-shrink-0'>
      <div className='dropdown' ref={dropdownLanguageRef}>
        <button type="button" className={`btn btn-sm btn-icon dropdown-toggle`} data-bs-toggle="dropdown" aria-expanded="false">
          {
            locale === "id" ?
              <ReactCountryFlag countryCode="ID" svg style={{ border: "solid 1px #000000", height: "auto" }} /> :
              <ReactCountryFlag countryCode="US" svg style={{ border: "solid 1px #000000", height: "auto" }} />
          }
        </button>
        <div className='dropdown-menu p-0' onClick={(e) => e.stopPropagation()}>
          <div className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold py-4 show">
            <div className="menu-item px-3 cursor-pointer" onClick={() => setIsShowModalLanguage(true)}>
              {
                locale === "id" ?
                  <span>
                    <ReactCountryFlag countryCode="US" svg className="me-1" />
                    English
                  </span> :
                  <span>
                    <ReactCountryFlag countryCode="ID" svg className="me-1" />
                    Indonesia
                  </span>
              }
            </div>
          </div>
        </div>
      </div>
      <div className='d-flex align-items-center gap-2'>
        <div className='dropdown position-relative' ref={dropdownRef}>
          <div className='notification-icon position-relative'>
            <div
              className='d-flex align-items-center cursor-pointer btn btn-icon btn-active-light btn-active-color-primary h-35px w-35px'
              role='button'
              onClick={toggleDropdown}
            >
              <i className='fas fa-bell fs-3'></i>
              {/* Notification Badge */}
              {(getUnreadNotif as Notification[] || [])?.length > 0 && (
                <span className='d-flex justify-content-center align-items-center notification-badge position-absolute badge rounded-circle bg-danger' style={{ top: -5, right: 0, width: '21px', height: '21px' }}>
                  <span style={{ fontSize: '10px' }}>{(getUnreadNotif as Notification[] || [])?.length > 99 ? '99+' : (getUnreadNotif as Notification[] || [])?.length}</span>
                </span>
              )}
            </div>
          </div>
          {isDropdownOpen && (
            <div
              className='dropdown-menu dropdown-menu-end p-0 show rounded-lg shadow-lg'
              style={{
                width: '300px',
                marginTop: '0.5rem',
                animation: 'dropdownFade 0.2s ease-in-out',
                position: 'absolute',
                right: '-10px'
              }}
            >
              <NotificationLog dataNotif={dataNotif as Notification[] || []} isLoadingNotif={isLoading} mutateNotif={mutateNotif} />
            </div>
          )}
        </div>
        <div className="d-flex align-items-center cursor-pointer btn btn-muted btn-active-light btn-active-color-primary h-30px h-md-40px px-3">
          <Link to={"/calendar"}>
            <i className="fas fa-calendar fs-3"></i>
          </Link>
        </div>
      </div>
      <div className="d-flex align-items-center cursor-pointer btn btn-muted btn-active-light btn-active-color-primary h-30px h-md-40px px-3" data-kt-menu-trigger='click' data-kt-menu-attach='parent' data-kt-menu-placement='bottom-end' data-kt-menu-flip='bottom'>
        {
          APP_ENV === 'development' &&
          // <div className="watermark me-5">Dev</div>
          <><img src="/media/logos/crm_dev.png" alt="logo" height="40px" className='me-6' /></>
        }
        {!userProfile?.profile_picture ?
          <span className="menu-icon">
            <i className="fas fa-user fs-3"></i>
          </span>
          :
          <div className='symbol symbol-circle symbol-35px'>
            <img src={userProfile?.profile_picture} className="profile-picture" alt="user"></img>
          </div>
        }
        <div className="fw-bolder d-flex align-items-center fs-5 text-dark ms-2 menu-title" id="txtNameHeader">{user.data.name}</div>
      </div>
      {
        showDetailNotification && (
          <DetailNotificationLog
            notification={detailNotification}
            onClose={() => setShowDetailNotification(false)}
            mutate={mutateNotif}
            open={showDetailNotification}
          />
        )
      }
      <HeaderUserMenu setShowUpdateProfilePicture={setShowUpdateProfilePicture} userProfile={userProfile?.profile_picture} />
      {
        showUpdateProfilePicture && (
          <ModalEditAvatar open={showUpdateProfilePicture} onClose={() => setShowUpdateProfilePicture(false)} userProfile={userProfile?.profile_picture} mutateProfile={mutateProfile} />
        )
      }
    </div>
  )
}

export { Topbar }
